import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useGetTransactionByIdQuery, transactionsApi } from "../api/transactions/transactions.api";
import {
    acquireSocketConnection,
    releaseSocketConnection,
    joinCommercialTransaction,
    leaveCommercialTransaction,
    onCommercialTransactionUpdated,
} from "../utils/socket-io";
import { POLLING_INTERVAL_MS } from "../utils/station-cache";

export const useTransaction = (commercialTransactionId?: string) => {
    const dispatch = useDispatch();
    const {
        data: commercialTransaction,
        isLoading: isCommercialTransactionLoading,
        error: commercialTransactionError,
        refetch: refetchCommercialTransaction
     } = useGetTransactionByIdQuery(commercialTransactionId ?? '', {
        skip: !commercialTransactionId,
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true,
        pollingInterval: POLLING_INTERVAL_MS,
        skipPollingIfUnfocused: true,
    });

    useEffect(() => {
        if (!commercialTransactionId) return;

        acquireSocketConnection();
        joinCommercialTransaction(commercialTransactionId);

        const unsubscribe = onCommercialTransactionUpdated(id => {
            if (id === commercialTransactionId) refetchCommercialTransaction();
        });

        return () => {
            unsubscribe();
            leaveCommercialTransaction(commercialTransactionId);
            releaseSocketConnection();
        };
    }, [commercialTransactionId, refetchCommercialTransaction]);

    const invalidateTransactionCache = (transactionId?: string) => {
        if (transactionId) {
            dispatch(
                transactionsApi.util.invalidateTags([{ type: 'Transaction', id: transactionId }])
            );
        } else {
            dispatch(
                transactionsApi.util.invalidateTags([{ type: 'Transaction' }])
            );
        }
    };

    return {
        commercialTransaction,
        isCommercialTransactionLoading,
        commercialTransactionError,
        refetchCommercialTransaction,
        invalidateTransactionCache,
    };
};
